import React, { memo } from "react";
import {
    Autocomplete,
    TextField,
} from "@mui/material";

/**
 * UncontrolledAutocomplete
 *
 * A standalone (non-react-hook-form) MUI Autocomplete.
 * React 19: ref is just a prop.
 */
const UncontrolledAutocomplete = (props) => {
    const {
        ref, // React 19 can pass ref as a prop
        label = "",
        placeholder = "",
        options = [],
        value = null,
        onChange,
        getOptionLabel,
        renderOption,
        filterOptions,
        isOptionEqualToValue,
        loading = false,
        disabled = false,
        error = "",
        size = "small",
        limitTags = 4,
        ...rest
    } = props;

    const resolveLabel = getOptionLabel ?? ((opt) =>
        typeof opt === "string" ? opt : opt?.label ?? ""
    );

    return (
        <Autocomplete
            options={options}
            value={value}
            onChange={(_, newVal) => onChange?.(newVal)}
            getOptionLabel={resolveLabel}
            renderOption={renderOption}
            filterOptions={filterOptions}
            isOptionEqualToValue={
                isOptionEqualToValue ??
                ((opt, val) =>
                    opt?.value === val?.value || opt === val)
            }
            loading={loading}
            disabled={disabled}
            size={size}
            limitTags={limitTags}
            sx={{ width: "100%", ...rest.sx }}
            {...rest}
            renderInput={(params) => (
                <TextField
                    {...params}
                    inputRef={ref}
                    label={label}
                    placeholder={placeholder || (label ? `Select ${label}` : "")}
                    error={Boolean(error)}
                    helperText={error || ""}
                    variant="outlined"
                    size={size}
                    fullWidth
                    sx={{
                        '& .MuiInputBase-root': {
                            fontSize: '12px',
                            borderRadius: '8px',
                            backgroundColor: '#f8fafc',
                        },
                    }}
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            style: { fontSize: "12px" },
                        },
                    }}
                />
            )}
        />
    );
};

export default UncontrolledAutocomplete;
